import { Block } from 'slate';
import urlParser from 'js-video-url-parser';

export const supportedVideoSites = ['youtube', 'vimeo'];

export const videoInfoFromURL = url => {
  const videoInfo = urlParser.parse(url);
  if (!videoInfo) {
    return false;
  }
  const { mediaType, id, provider } = videoInfo;
  if (!(mediaType === 'video' && !supportedVideoSites[provider])) {
    return false;
  }
  return { site: provider, key: id };
};

export const videoInfoToURL = (key, site) => {
  if (!supportedVideoSites.includes(site)) {
    return false;
  }
  const videoInfo = {
    provider: site,
    id: key,
    mediaType: 'video',
  };
  const generatedUrl = urlParser.create({ videoInfo, format: 'embed' });
  return generatedUrl && `https:${generatedUrl}`;
};

export function EmbedVideo() {
  return {
    normalizeNode: (node, editor, next) => {
      if (node.type === 'paragraph') {
        const inlines = node.getInlinesAsArray();
        if (inlines.length === 1) {
          const singleInline = inlines.pop();
          if (singleInline.type === 'linkified-link') {
            const text = singleInline.data.get('text');
            if (text === node.text) {
              const url = singleInline.data.get('url');
              const videoInfo = videoInfoFromURL(url);
              if (videoInfo) {
                const { key, site } = videoInfo;
                const data = { src: key, site };
                const videoTemplate = { type: 'video-block', data };
                const videoNode = Block.create(videoTemplate);
                editor.replaceNodeByKey(node.key, videoNode);
              }
            }
          }
        }
      }

      return next();
    },
  };
}
